import script from "./ReactionPicker.vue?vue&type=script&lang=ts&setup=true"
export * from "./ReactionPicker.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__